/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { type Insight as BaseInsight, registerStandardChartInsight } from '../insightManager';
import { toArray } from '../../util/data';
import {
  retrieveTwoDimArray,
  calculateColumnAverages,
  handleMultipleSeries,
  handleAnimation
} from '../helper';

type InsightData = {
  /** 计算方式 */
  purpose: string;
  /** 线的配置 @see https://echarts.apache.org/zh/option.html#series-bar.markLine.data */
  line?: unknown;
  /** 弱化系列 */
  blurSeries?: unknown;
};

const type = 'OverallTrend';
const INSIGHT_FLAG = `insight_${type}`;

interface Insight extends BaseInsight<InsightData[]> {
  readonly type: typeof type;
}

registerStandardChartInsight<Insight>({
  type,
  filter: option => {
    return (
      toArray(option.xAxis).length > 0 &&
      toArray(option.yAxis).length > 0 &&
      !toArray(option.series).some(item => !['line', 'bar'].includes(item.type))
    );
  },
  clear: {
    onOptionUpdate(option) {
      option.series = toArray(option.series).map(series => {
        series.markLine = series.markLine || {};
        series.markLine.data = (series.markLine.data || []).filter(
          item => item.__insightFlag !== INSIGHT_FLAG
        );

        return series;
      });
    }
  },
  render: {
    onOptionUpdate(context, option, legendIns) {
      const insight = context.insightOption;
      const { animationDuration = 0 } = insight;
      const { linkLegend = false } = insight;

      function renderLine(data: InsightData) {
        const { purpose, line: lineOpt = {}, blurSeries = {} } = data;
        if (purpose !== 'average') {
          return;
        }

        option.series = context.util.data.toArray(option.series);
        const series = context.util.data.toArray(option.series)[0];
        const matrix = retrieveTwoDimArray(option.series);
        const average = calculateColumnAverages(matrix);
        series.markLine = series.markLine || {};
        series.markLine.data = series.markLine.data || [];

        const line = [
          {
            ...(lineOpt as any),
            symbol: 'none',
            coord: [option.xAxis[0].data[0], average[0]]
          },
          {
            ...(lineOpt as any),
            coord: [
              option.xAxis[0].data[option.xAxis[0].data.length - 1],
              average[average.length - 1]
            ]
          }
        ];
        (line as unknown as { __insightFlag: string }).__insightFlag = INSIGHT_FLAG;

        series.markLine.data.push(line);
        handleAnimation(series.markLine, animationDuration);

        // * 弱化主图
        const blurSeriesOpt = JSON.parse(JSON.stringify(blurSeries));
        option.series.forEach(seriesItem => {
          if (!seriesItem.areaStyle) {
            delete blurSeriesOpt.areaStyle;
          }
        });
        handleMultipleSeries(option, -1, legendIns!, blurSeriesOpt, linkLegend);
      }

      insight.data.forEach(item => renderLine(item));
    }
  }
});
